import { useSelector } from 'react-redux';

const useRoleAccess = () => {

    const { notificationAccess } = useSelector(state => state.auth);
    return notificationAccess;
};

export default useRoleAccess;